export default __webpack_public_path__ + "static/media/BEXEN_Cardio_Horiz_Blanco.2ddfb6c4.png";